import React from "react";
import StaticPostLayout from "../components/StaticPostLayout";
import MapRockyMountainNationalPark from "../components/Maps/rocky-mountain-national-park";
import RockyMountainNationalParkInfo from "../components/TripInfo/rocky-mountain-national-park";

class RockyMountainNationalPark extends React.Component {
  render() {
    return (
      <StaticPostLayout
        title="Rocky Mountain National Park: 4-Day Itinerary"
        category="National Parks"
        slug="rocky-mountain-national-park-itinerary"
        excerpt="High country Colorado — Trail Ridge Road crosses 12,000-foot alpine tundra, Bear Lake mirrors Hallett Peak, and elk bugle in Moraine Park every October."
        tags={["National Parks", "Hiking", "Colorado", "Wildlife", "Alpine"]}
        readTime="8 min read"
        mapComponent={<MapRockyMountainNationalPark />}
        whereToStay={[
          { name: 'Hotels in Estes Park', type: 'East Entrance Gateway · Estes Park, CO', url: 'https://www.booking.com/searchresults.html?ss=Estes+Park%2C+Colorado' },
          { name: 'YMCA of the Rockies', type: 'Affordable Lodging · Estes Park', url: 'https://www.booking.com/searchresults.html?ss=Estes+Park%2C+Colorado' },
          { name: 'Hotels in Grand Lake', type: 'West Entrance · Grand Lake, CO', url: 'https://www.booking.com/searchresults.html?ss=Grand+Lake%2C+Colorado' },
        ]}
      >
        <RockyMountainNationalParkInfo />
      </StaticPostLayout>
    );
  }
}

export default RockyMountainNationalPark;
